export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', count: 1280 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 960 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 850 },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', count: 620 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 740 },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line', count: 390 },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line', count: 560 },
  { slug: 'history', name: '古风', icon: 'ri-ancient-gate-line', count: 430 },
]

export const comics = [
  {
    id: 1,
    title: '我的ID是江南美人',
    author: '淇萌',
    category: 'love',
    rating: 9.6,
    views: '3280万',
    status: '连载中',
    updateChapter: '第128话',
    description: '相貌平凡的女孩通过整容手术变成了校园女神，却发现美貌带来的并不只有赞美和关注。在这个看脸的世界里，她开始重新思考什么才是真正的美。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20beautiful%20young%20woman%20with%20long%20dark%20hair%20in%20school%20uniform%2C%20soft%20pink%20and%20peach%20tones%2C%20romantic%20atmosphere%2C%20clean%20modern%20manga%20art%20style%2C%20delicate%20lighting%2C%20simple%20gradient%20background%20with%20cherry%20blossoms&width=480&height=640&seq=comic-cover-01&orientation=portrait',
    tags: ['校园', '恋爱', '颜值'],
    chapters: [
      { num: 128, title: '新的开始', date: '2026-07-06' },
      { num: 127, title: '真心话', date: '2026-06-29' },
      { num: 126, title: '意外的相遇', date: '2026-06-22' },
      { num: 125, title: '雨中的告白', date: '2026-06-15' },
      { num: 124, title: '隐藏的真相', date: '2026-06-08' },
      { num: 123, title: '心动的瞬间', date: '2026-06-01' },
    ],
    comments: [
      { user: '漫画迷小王', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20avatar%20portrait%20in%20casual%20style%2C%20friendly%20smile%2C%20clean%20soft%20lighting%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-01&orientation=squarish', rating: 5, text: '画风太美了！每一话都让人心动不已，男女主角的感情线写得太细腻了。', date: '2026-07-05' },
      { user: '追番少女', avatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Asian%20woman%20avatar%20with%20long%20hair%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20simple%20warm%20pastel%20background&width=80&height=80&seq=avatar-02&orientation=squarish', rating: 5, text: '每周必追！江南美人的故事真的越看越上头，强烈推荐！', date: '2026-07-04' },
      { user: '二次元小王子', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20portrait%20with%20glasses%2C%20thoughtful%20expression%2C%20warm%20soft%20lighting%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-03&orientation=squarish', rating: 4, text: '剧情走向越来越有意思了，期待下一话！', date: '2026-07-03' },
    ],
  },
  {
    id: 2,
    title: '全知读者视角',
    author: '싱숑',
    category: 'fantasy',
    rating: 9.8,
    views: '5620万',
    status: '连载中',
    updateChapter: '第215话',
    description: '唯一读过某部小说结局的金独子，在小说世界变成现实的那一刻，成为了唯一知道这个世界结局的人。他必须利用自己的知识在这个末日般的世界中存活下去。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20young%20man%20in%20dark%20coat%20with%20mysterious%20glowing%20book%2C%20fantasy%20theme%2C%20dramatic%20lighting%2C%20teal%20and%20gold%20color%20palette%2C%20clean%20modern%20manga%20art%2C%20simple%20gradient%20background&width=480&height=640&seq=comic-cover-02&orientation=portrait',
    tags: ['奇幻', '生存', '冒险'],
    chapters: [
      { num: 215, title: '终章前夕', date: '2026-07-07' },
      { num: 214, title: '最后的壁垒', date: '2026-06-30' },
      { num: 213, title: '觉醒之力', date: '2026-06-23' },
      { num: 212, title: '命运的抉择', date: '2026-06-16' },
      { num: 211, title: '深渊之底', date: '2026-06-09' },
      { num: 210, title: '黎明之前', date: '2026-06-02' },
    ],
    comments: [
      { user: '奇幻迷阿杰', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20with%20cool%20casual%20style%2C%20confident%20smile%2C%20soft%20lighting%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-04&orientation=squarish', rating: 5, text: '神作！世界观设定太绝了，每次更新都要第一时间看！', date: '2026-07-06' },
      { user: '书虫小雪', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20glasses%20and%20long%20black%20hair%2C%20gentle%20smile%2C%20soft%20warm%20lighting%2C%20simple%20pastel%20background&width=80&height=80&seq=avatar-05&orientation=squarish', rating: 5, text: '小说的改编做得太好了，画面表现力比文字还要震撼！', date: '2026-07-05' },
    ],
  },
  {
    id: 3,
    title: '女神降临',
    author: '야옹이',
    category: 'comedy',
    rating: 9.4,
    views: '8920万',
    status: '已完结',
    updateChapter: '第250话（完结）',
    description: '因为长相被欺负的女孩通过化妆技巧逆袭成为校园女神，在两个截然不同的男生之间展开了一段爆笑又感人的三角恋故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20beautiful%20young%20woman%20with%20makeup%2C%20holding%20cosmetics%2C%20bright%20and%20vibrant%20colors%2C%20comedic%20cute%20expression%2C%20clean%20modern%20manga%20art%2C%20simple%20pastel%20pink%20background&width=480&height=640&seq=comic-cover-03&orientation=portrait',
    tags: ['校园', '搞笑', '化妆'],
    chapters: [
      { num: 250, title: '最终话：女神之路', date: '2026-05-30' },
      { num: 249, title: '选择的答案', date: '2026-05-23' },
      { num: 248, title: '真心', date: '2026-05-16' },
    ],
    comments: [
      { user: '爆笑达人', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20with%20big%20laughing%20expression%2C%20friendly%20vibe%2C%20soft%20lighting%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-06&orientation=squarish', rating: 5, text: '从头笑到尾！女主真的太可爱了，完结了好不舍！', date: '2026-06-01' },
    ],
  },
  {
    id: 4,
    title: '甜蜜的陷阱',
    author: '이현민',
    category: 'suspense',
    rating: 9.3,
    views: '1560万',
    status: '连载中',
    updateChapter: '第87话',
    description: '看似完美的婚姻背后隐藏着骇人的秘密。当妻子开始怀疑丈夫的真实身份时，一场危险的猫鼠游戏悄然展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20style%20illustration%2C%20elegant%20woman%20in%20dark%20dress%20with%20mysterious%20shadowy%20background%2C%20suspense%20atmosphere%2C%20deep%20burgundy%20and%20dark%20tones%2C%20clean%20modern%20manga%20art%2C%20dramatic%20lighting&width=480&height=640&seq=comic-cover-04&orientation=portrait',
    tags: ['悬疑', '惊悚', '婚姻'],
    chapters: [
      { num: 87, title: '隐藏的地下室', date: '2026-07-05' },
      { num: 86, title: '他说谎了', date: '2026-06-28' },
    ],
    comments: [
      { user: '推理控', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20serious%20expression%2C%20detective%20vibe%2C%20soft%20lighting%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-07&orientation=squarish', rating: 5, text: '每话结尾都留钩子，根本停不下来！', date: '2026-07-06' },
    ],
  },
  {
    id: 5,
    title: '花书生恋爱史',
    author: '김수현',
    category: 'history',
    rating: 9.5,
    views: '2340万',
    status: '连载中',
    updateChapter: '第96话',
    description: '朝鲜时代的书生与神秘花仙相遇，跨越现实与幻想的浪漫古风爱情故事。在传统与奇幻的交织中，两个灵魂逐渐靠近。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20style%20illustration%20of%20handsome%20scholar%20in%20traditional%20hanbok%20with%20flower%20petals%2C%20romantic%20ancient%20Korean%20setting%2C%20soft%20warm%20peach%20and%20cream%20tones%2C%20clean%20modern%20manga%20art&width=480&height=640&seq=comic-cover-05&orientation=portrait',
    tags: ['古风', '恋爱', '奇幻'],
    chapters: [
      { num: 96, title: '花开花落', date: '2026-07-04' },
      { num: 95, title: '书生的誓言', date: '2026-06-27' },
    ],
    comments: [
      { user: '古风控', avatar: 'https://readdy.ai/api/search-image?query=Elegant%20young%20Asian%20woman%20in%20traditional%20style%2C%20graceful%20expression%2C%20soft%20warm%20lighting%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-08&orientation=squarish', rating: 5, text: '画风太精致了，每一格都能当壁纸！', date: '2026-07-05' },
    ],
  },
  {
    id: 6,
    title: '幽灵教室',
    author: '박지은',
    category: 'horror',
    rating: 9.1,
    views: '890万',
    status: '连载中',
    updateChapter: '第42话',
    description: '深夜的教室里传出奇怪的声音，一群学生决定在午夜探险，却发现了学校隐藏的恐怖秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20style%20illustration%20of%20dark%20empty%20school%20classroom%20with%20ghostly%20figure%2C%20eerie%20greenish%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20modern%20manga%20art%2C%20dark%20ambient%20background&width=480&height=640&seq=comic-cover-06&orientation=portrait',
    tags: ['惊悚', '校园', '灵异'],
    chapters: [
      { num: 42, title: '午夜钟声', date: '2026-07-03' },
    ],
    comments: [
      { user: '灵异爱好者', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20with%20mysterious%20expression%2C%20dark%20casual%20style%2C%20soft%20lighting%2C%20simple%20dark%20background&width=80&height=80&seq=avatar-09&orientation=squarish', rating: 4, text: '晚上看真的有点吓人，但就是停不下来！', date: '2026-07-04' },
    ],
  },
  {
    id: 7,
    title: '便利店之夜',
    author: '최유나',
    category: 'daily',
    rating: 9.2,
    views: '1120万',
    status: '连载中',
    updateChapter: '第63话',
    description: '深夜便利店里发生的温暖小故事。每一个走进便利店的客人，都带着自己不为人知的故事和秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20style%20illustration%2C%20warm%20night%20convenience%20store%20interior%20with%20soft%20lighting%2C%20young%20woman%20cashier%20smiling%2C%20cozy%20atmosphere%2C%20clean%20modern%20manga%20art%2C%20simple%20warm%20yellow%20tones&width=480&height=640&seq=comic-cover-07&orientation=portrait',
    tags: ['日常', '治愈', '暖心'],
    chapters: [
      { num: 63, title: '午夜来客', date: '2026-07-02' },
    ],
    comments: [
      { user: '治愈系小明', avatar: 'https://readdy.ai/api/search-image?query=Gentle%20young%20Asian%20man%20with%20warm%20smile%2C%20soft%20lighting%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-10&orientation=squarish', rating: 5, text: '每一话都让人心里暖暖的，很治愈。', date: '2026-07-03' },
    ],
  },
  {
    id: 8,
    title: '剑圣之名',
    author: '정태호',
    category: 'action',
    rating: 9.7,
    views: '4560万',
    status: '连载中',
    updateChapter: '第189话',
    description: '传说中的剑圣重生到了一个没有剑术的世界。为了守护珍视之人，他必须重新踏上剑道巅峰，挑战各路强者。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20illustration%20of%20powerful%20swordsman%20with%20glowing%20sword%2C%20dynamic%20pose%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20accents%2C%20clean%20modern%20manga%20art%2C%20simple%20dark%20background&width=480&height=640&seq=comic-cover-08&orientation=portrait',
    tags: ['动作', '重生', '剑术'],
    chapters: [
      { num: 189, title: '最终决战', date: '2026-07-07' },
      { num: 188, title: '觉醒的剑意', date: '2026-06-30' },
    ],
    comments: [
      { user: '热血青年', avatar: 'https://readdy.ai/api/search-image?query=Determined%20young%20Asian%20man%20with%20intense%20gaze%2C%20friendly%20expression%2C%20soft%20lighting%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-11&orientation=squarish', rating: 5, text: '打斗分镜太燃了！每次看完都热血沸腾！', date: '2026-07-07' },
    ],
  },
  {
    id: 9,
    title: '恶魔的契约',
    author: '한소희',
    category: 'fantasy',
    rating: 9.0,
    views: '1670万',
    status: '连载中',
    updateChapter: '第55话',
    description: '为了拯救妹妹的生命，姐姐与恶魔签订了契约。然而契约的代价远超她的想象，一场奇幻冒险就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20style%20illustration%20of%20mysterious%20woman%20with%20dark%20magical%20aura%2C%20purple%20and%20crimson%20lighting%2C%20demonic%20contract%20theme%2C%20clean%20modern%20manga%20art%2C%20simple%20dark%20gradient%20background&width=480&height=640&seq=comic-cover-09&orientation=portrait',
    tags: ['奇幻', '恶魔', '姐妹'],
    chapters: [
      { num: 55, title: '契约的代价', date: '2026-07-01' },
    ],
    comments: [
      { user: '奇幻控', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20mysterious%20aura%2C%20dark%20elegant%20style%2C%20soft%20lighting%2C%20simple%20dark%20background&width=80&height=80&seq=avatar-12&orientation=squarish', rating: 4, text: '故事情节很吸引人，画风也很棒！', date: '2026-07-02' },
    ],
  },
  {
    id: 10,
    title: '恋爱操作团',
    author: '윤지원',
    category: 'love',
    rating: 9.3,
    views: '2780万',
    status: '连载中',
    updateChapter: '第78话',
    description: '一个专门帮助别人谈恋爱的神秘组织，却在帮助客户的过程中，成员们自己也陷入了爱情的漩涡。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20style%20illustration%2C%20three%20young%20people%20in%20fashionable%20outfits%20with%20love%20theme%2C%20bright%20pastel%20pink%20and%20coral%20tones%2C%20clean%20modern%20manga%20art%2C%20simple%20gradient%20background&width=480&height=640&seq=comic-cover-10&orientation=portrait',
    tags: ['恋爱', '职场', '喜剧'],
    chapters: [
      { num: 78, title: '双向暗恋', date: '2026-07-06' },
    ],
    comments: [
      { user: '甜剧达人', avatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Asian%20woman%20with%20bright%20smile%2C%20friendly%20vibe%2C%20soft%20warm%20lighting%2C%20simple%20pastel%20background&width=80&height=80&seq=avatar-13&orientation=squarish', rating: 5, text: '甜到爆！男主太会撩了，少女心炸裂！', date: '2026-07-07' },
    ],
  },
  {
    id: 11,
    title: '影子猎人',
    author: '강민수',
    category: 'action',
    rating: 9.4,
    views: '3450万',
    status: '连载中',
    updateChapter: '第132话',
    description: '在阴影中潜行的猎人，专门猎杀隐藏在人类社会中的超自然生物。黑暗中的战斗，从未停止。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20illustration%20of%20cool%20hunter%20in%20black%20trench%20coat%20with%20silver%20weapons%2C%20urban%20night%20setting%2C%20dynamic%20composition%2C%20clean%20modern%20manga%20art%2C%20dark%20blue%20tones&width=480&height=640&seq=comic-cover-11&orientation=portrait',
    tags: ['动作', '超自然', '暗黑'],
    chapters: [
      { num: 132, title: '暗影降临', date: '2026-07-05' },
    ],
    comments: [
      { user: '暗黑系', avatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20Asian%20man%20in%20dark%20style%2C%20intense%20expression%2C%20soft%20low%20lighting%2C%20simple%20dark%20background&width=80&height=80&seq=avatar-14&orientation=squarish', rating: 5, text: '世界观看得很过瘾，期待更多！', date: '2026-07-06' },
    ],
  },
  {
    id: 12,
    title: '猫咪咖啡厅',
    author: '이서연',
    category: 'daily',
    rating: 9.5,
    views: '1980万',
    status: '连载中',
    updateChapter: '第45话',
    description: '一家隐藏在巷弄里的猫咪咖啡厅，主人和猫咪们的日常温馨故事。每一杯咖啡都温暖人心，每一只猫咪都有故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20style%20illustration%2C%20cozy%20cat%20cafe%20interior%20with%20cute%20cats%20and%20young%20woman%20barista%2C%20warm%20coffee%20tones%2C%20soft%20lighting%2C%20clean%20modern%20manga%20art%2C%20simple%20warm%20background&width=480&height=640&seq=comic-cover-12&orientation=portrait',
    tags: ['日常', '治愈', '猫咪'],
    chapters: [
      { num: 45, title: '新来的小橘猫', date: '2026-07-04' },
    ],
    comments: [
      { user: '猫奴一枚', avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20cat%20lover%20vibe%2C%20gentle%20smile%2C%20soft%20warm%20lighting%2C%20simple%20pastel%20background&width=80&height=80&seq=avatar-15&orientation=squarish', rating: 5, text: '猫咪画得太可爱了，每只都想撸！', date: '2026-07-05' },
    ],
  },
]

export const hotComics = comics.slice(0, 8)

export const latestUpdates = [...comics].sort(() => Math.random() - 0.5).slice(0, 6)

export const featuredComic = comics[0]